export default __webpack_public_path__ + "static/date-label-do-3-light-93be6d83d3eb7f382ffc976445a30fca428bc8fcabd1737af93a724049a6ccbe.png";